module.exports = __webpack_public_path__ + "img/law2m-m@1.b949b802.webp";